<template>
    <PopupRouterViewDetail label="Repair Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Repair" class="mb-3">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" label-cols-lg="12" label="Control Card Number" id="fieldset-control-card" size="sm" :model.sync="model.controlCardId"   :selected="model.controlCard != null ? model.controlCard.controlCardNumber : ''" @input="getControlCards" @change="updateData"  :isUpdatable="true"  :isSelectMethodExists="true" :isEditable="false" @onSelectMethod="setSelectedControlCard" />
						<app-input-textbox label-cols-lg="12" label="Part Number" label-for="label-repair-control-card-part-number" :model="(model.controlCard != null && model.controlCard.part != null) ? model.controlCard.part.partNumber : null" id="label-repair-control-card-part-number"
						:isEditable="false"/>
						<app-input-textbox label-cols-lg="12" label="Part Name" label-for="label-repair-control-card-part-name" :model="(model.controlCard != null && model.controlCard.part != null) ? model.controlCard.part.partName : null" id="label-repair-control-card-part-name"
						:isEditable="false"/>
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-case-qty" label-cols-lg="12"  label="Case Qty" label-for="input-case-qty" size="sm" :model.sync="model.caseQty"  @change="updateData" :isEditable="false" />
						<app-input-textbox id="fieldset-qty-ok" label-cols-lg="12"  label="Qty OK" label-for="input-qty-ok" size="sm" :model.sync="model.qtyOk"  @change="updateData" :isEditable="false" />
						<app-input-textbox id="fieldset-qty-ng" label-cols-lg="12"  label="Qty Ng" label-for="input-qty-ng" size="sm" :model.sync="model.qtyNg"  @change="updateData" :isEditable="false" />
				</b-col>

            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import Repair from '@/models/Repair/Repair';
import RepairList from '@/models/Repair/RepairList';
import RepairFilter from '@/filters/Repair/RepairFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppLabel from '@/components/AppLabel';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputTextbox,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterRepair : null,
			currentRepairPage : 1,
			repairPageSize: 10,
			sortByRepair: '',
			sortDescRepair: '',
			controlCards: [],
			controlCards: [],
			isControlCardComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isControlCardComboLoading: false,
		}
	},
	methods : {
		getRepair : async function(id) {
			this.isBusy = true;
			Repair.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				if(this.model.controlCardId != null) {
					promises.push(
						this.getControlCard(this.model.controlCardId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadRepair = true;
			this.filterRepair.id = this.modelId;
			Repair.downloadDataDetail(this, this.filterRepair).then(result => {
				this.isDownloadRepair = false;
			}).catch(error => { this.isDownloadRepair = false; })
		},
		getRepairs : async function(input) {
			let filter = new RepairFilter();
			if (input != undefined) {
				filter.ControlCard = input;
			}
			this.isRepairComboLoading = true;
			Repair.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.repairs = result.data
				}
				this.isRepairComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedControlCard(item) {
			if(item == undefined || item == null) {
				this.model.controlCardId = null;
				this.model.controlCard = null;
			} else {
				this.model.controlCardId = item.id;
				this.model.controlCard = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getControlCard : async function(id) {
			ControlCard.getData(this, id).then(result => {
				this.model.controlCard = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.repairInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						Repair.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'repairindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						Repair.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'repairindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					Repair.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getRepair(id);
					});
				}
			});
		},
		onHidden() {
			this.getRepairs();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterRepair = new RepairFilter();
		//this.getControlCards();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getRepair(id);
			} else {
				this.modelId = id;
				this.getRepair(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
